import React, { useMemo, useState, useCallback, useRef } from 'react'
import AsyncSelect from 'react-select/async';
import { useOktaAuth } from '@okta/okta-react';
import debounce from 'debounce-async';
import { FILTER_VARIANTS, COMPANY_TYPES } from "../utils/surveyLiterals";

const isOptionSelected = (option, values) => {
    return values.some(({ value }) => option.value === value);
};

export const SelectFilter = ({ loadOptionsFunction, onChange, variant, abortControllerRef }) => {
    const { authState } = useOktaAuth();
    const [lastOptions, setLastOptions] = useState([]);
    const [showOptions, setShowOptions] = useState(false);

    const loadOptions = useMemo(() => {
        return debounce(async (inputValue) => {
            let options = undefined
            //Abort any pending requests
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            // Create new abort controller
            const newAbortController = new AbortController();
            //Store current controller ref
            abortControllerRef.current = newAbortController;
            switch (variant) {
                case FILTER_VARIANTS.SUPPLIER:
                    const suppliers = await loadOptionsFunction(inputValue, authState.accessToken.accessToken, COMPANY_TYPES.DEERE, newAbortController.signal);
                    options = suppliers.map((supplier) => ({
                        value: supplier.supplierNumber,
                        label: `${supplier.supplierNumber} - ${supplier.supplierName}`
                    }))
                    setLastOptions(options)
                    return options
                case FILTER_VARIANTS.DEERECONTACT:
                    const contacs = await loadOptionsFunction(inputValue, authState.accessToken.accessToken, COMPANY_TYPES.DEERE, newAbortController.signal);
                    options = contacs.map((contact) => ({
                        value: contact.userId,
                        label: `${contact.lastName}, ${contact.firstName} - ${contact.userId}`
                    }))
                    setLastOptions(options)
                    return options   
                case FILTER_VARIANTS.NONDEERESUPPLIER:
                    const nonDeereSuppliers = await loadOptionsFunction(inputValue, authState.accessToken.accessToken, COMPANY_TYPES.NONDEERE, newAbortController.signal);
                    options = nonDeereSuppliers.map((supplier) => ({
                        value: supplier.supplierNumber,
                        label: `${supplier.supplierNumber} - ${supplier.supplierName}`
                    }))
                    setLastOptions(options)
                    return options
                case FILTER_VARIANTS.COMPANYCONTACT:
                    const contacts = await loadOptionsFunction(inputValue, authState.accessToken.accessToken, COMPANY_TYPES.NONDEERE, newAbortController.signal);
                    options = contacts.map((contact) => ({
                        value: contact.email,
                        label: `${contact.email}`
                    }))
                    setLastOptions(options)
                    return options   
                default:
                    break;
            }
        }, 300);
    }, [authState.accessToken.accessToken, loadOptionsFunction, variant])

    const handleInputChange = useCallback((typedOption) => {
        (typedOption.length > 1) ? setShowOptions(true) : setShowOptions(false);
    }, []);

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? 'black' : 'black'
        }),
        control: base => ({
            ...base,
            height: 35,
            minHeight: 35,
            width: 'auto'
        }),
        menu: base=> ({
            ...base,
            position:'relative'
        }),
        dropdownIndicator: base => ({
            ...base,
            height: 35,
            minHeight: 35,
        }),
        placeholder: base => ({
            ...base,
        }),
        valueContainer: base => ({
            ...base,
            height: 35,
            minHeight: 35,
        }),
        singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.5 : 1;

            return { ...provided, opacity };
        }
    }

    return (
        <AsyncSelect
            cacheOptions={true}
            defaultOptions
            loadOptions={showOptions ? loadOptions : null}
            value={lastOptions.find((option) => option.value === '266')}
            isOptionSelected={isOptionSelected}
            onInputChange={handleInputChange}
            isClearable={true}
            styles={customStyles}
            noOptionsMessage={() => 'Please enter 3 or more characters to search'}
            onChange={onChange}
        />
    )
}